import request from '@/utils/request'

// 查询财务情况列表
export function listFinancialsituation(query) {
  return request({
    url: '/screen/creditlibrary/financialsituation/list',
    method: 'get',
    params: query
  })
}

// 查询财务情况详细
export function getFinancialsituation(pid) {
  return request({
    url: '/screen/creditlibrary/financialsituation/detail/' + pid,
    method: 'get'
  })
}

// 新增财务情况
export function addFinancialsituation(data) {
  return request({
    url: '/screen/creditlibrary/financialsituation/add',
    method: 'post',
    data: data
  })
}

// 修改财务情况
export function updateFinancialsituation(data) {
  return request({
    url: '/screen/creditlibrary/financialsituation/edit',
    method: 'post',
    data: data
  })
}

// 删除财务情况
export function delFinancialsituation(pid) {
  return request({
    url: '/screen/creditlibrary/financialsituation/delete/' + pid,
    method: 'get'
  })
}
